<template>
  <div class="svg-wrap" v-loading="loading">
    <div ref="container" style="width: 100%;height:100%;"></div>

    <el-popover placement="bottom" trigger="manual" :visible-arrow="false" :content="content" v-model="visible" popper-class="d3-scale-percent">
      <div class="btn" slot="reference" @click="visible = !visible"></div>
    </el-popover>
  </div>
</template>

<script>
import { getEnterpriseGraph } from '@/views/clue/api/newClueApi'
import EnterpriseGraph from '@/components/D3Tree/enterpriseGraph'
import { v4 as uuidV4 } from 'uuid'

export default {
  name: 'EquityPenetration',
  components: {

  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      content: '100%',
      loading: false
    }
  },
  mounted() {
    this.getEnterpriseGraph()
  },
  methods: {
    async getEnterpriseGraph() {
      this.loading= true
      const { hid, companyName } = this.$route.query
      const { code, data } = await getEnterpriseGraph({ hid })
      this.loading= false

      EnterpriseGraph.prototype.emit = this.percentHandle
      const tree = new EnterpriseGraph(this.$refs.container, {
        props: {
          label: 'name',
          children: 'child'
        }
      })
      tree.create(data)
    },
    sortOutData(data) {
      const enterpriseGraphData = []

      const fields = [
        { field: 'actualController', valueName: '实际控制人' },
        { field: 'beneficialOwnerList', valueName: '最终受益人' },
        { field: 'branchInfoList', valueName: '分支机构' },
        { field: 'companyExecutivesInfos', valueName: '主要成员' },
        { field: 'companygudongInfoList', valueName: '股东信息' },
        { field: 'customerList', valueName: '客户' },
        { field: 'holdingCompanies', valueName: '控股企业' },
        { field: 'investmentInfoList', valueName: '对外投资' },
        { field: 'legalPersonName', valueName: '法定代表人' },
        { field: 'mainCompany', valueName: '总公司' },
        { field: 'supplierList', valueName: '供应商' },
      ]

      fields.forEach(f => {
        if (data[f.field]) {
          const children = []
          if (typeof data[f.field] == 'string') {
            children.push({
              id: uuidV4(),
              name: data[f.field],
            })
          }
          enterpriseGraphData.push({
            id: uuidV4(),
            name: f.valueName,
            children: []
          })
        }
      })

    },

    percentHandle(scale) {
      this.visible = true
      this.content = Math.floor(scale * 100) + '%'
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.visible = false
      }, 1000)
    }
  }
}
</script>

<style scoped lang="scss">
@import '~/src/views/clue/page/style/enterprise.scss';
</style>
